import { render, staticRenderFns } from "./FilterWithIcon.vue?vue&type=template&id=3d453421&scoped=true&"
import script from "./FilterWithIcon.vue?vue&type=script&lang=js&"
export * from "./FilterWithIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d453421",
  null
  
)

export default component.exports